<cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth">
  <span class="cap-table-wrapper-title" style="font-weight: bold">
    <h3 class="mt-md-2 mb-md-2">{{ title | translate }}</h3>
  </span>
  <ng-container class="cap-table-wrapper-content">
    <cap-list-loader [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
      <div class="cap-list-loader-content">
        <table class="cap-table-detail">
          <thead>
            <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
          </thead>
          <tbody>
            <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
          </tbody>
        </table>
      </div>
    </cap-list-loader>
  </ng-container>
</cap-beschreibung-table-wrapper>

<ng-template #tableHeaders>
  <tr>
    <th style="width: 30%">{{ "Name" | translate }}</th>
    <th style="width: 35%">{{ "AdressenN" | translate }}</th>
    <th style="width: 35%">{{ "Art" | translate }}</th>
  </tr>
</ng-template>
<ng-template #tableRows>
  @for (stammperson of listLoader?.items; track stammperson) {
    <tr>
      <td>
        @if (stammperson.version) {
          <span>
            <cap-link
              [enableNavigation]="showPersonendaten(stammperson.auskunftsperre)"
              [params]="[stammperson.masterId?.id, stammperson.version?.id?.id]"
              [target]="navTargets.NAV_PERSON_STAMM"
              [tooltipParams]="stammperson | tooltipPersonstammPipe">
              <cap-kompakt-stammperson [auskunftsperre]="stammperson.auskunftsperre" [item]="stammperson.version"></cap-kompakt-stammperson>
            </cap-link>
          </span>
        } @else {
          {{ "GemaessGrundbuch" | translate }}
        }
      </td>
      <td>
        @if (showAdressen(stammperson.auskunftsperre)) {
          @if (stammperson.adressen) {
            <span>
              @for (entry of stammperson.adressen; track entry) {
                <cap-kompakt-personenadresse
                  [auskunftsperre]="stammperson.auskunftsperre"
                  [entry]="stammperson?.version"
                  [item]="entry"
                  style="display: block"></cap-kompakt-personenadresse>
              }
            </span>
          } @else {
            {{ "GemaessGrundbuch" | translate }}
          }
        } @else {
          <div>
            <span style="font-style: italic">{{ "stammperson-adresssperre" | translate }}</span>
          </div>
        }
      </td>
      <td>
        @if (stammperson.version?.art && showPersonendaten(stammperson.auskunftsperre)) {
          <span>
            {{ stammperson.version.art | translate }}
          </span>
        }
      </td>
    </tr>
  }
</ng-template>
